import React from 'react';
import UtilityService from '../../../services/UtilityService';
import { GiftCardContract } from '../../../types/GiftCard';

interface GiftCardPaymentSummaryProps {
  giftCards: GiftCardContract[];
  hasPaymentProfileMethod?: boolean;
}

const GiftCardPaymentSummary: React.FC<GiftCardPaymentSummaryProps> = ({
  giftCards,
  hasPaymentProfileMethod = false,
}: GiftCardPaymentSummaryProps) => {
  const renderedGiftCards = giftCards.map((giftCard, index) => (
    <div className="leading-5 w-44 sm:w-auto" key={giftCard.code}>
      {hasPaymentProfileMethod || index > 0 ? 'And ' : ''} Gift Card Code{' '}
      <strong>{UtilityService.formatGiftCardCode(giftCard.code)}</strong> with a
      balance of{' '}
      <strong>{UtilityService.formatAmount(giftCard.value, '$')}</strong>.
    </div>
  ));

  return <div className="pt-0.5">{renderedGiftCards}</div>;
};

export default GiftCardPaymentSummary;
